import { render, staticRenderFns } from "./OtherUserGroupTable.vue?vue&type=template&id=09927ae0&scoped=true&lang=pug"
import script from "./OtherUserGroupTable.vue?vue&type=script&lang=ts"
export * from "./OtherUserGroupTable.vue?vue&type=script&lang=ts"
import style0 from "./OtherUserGroupTable.vue?vue&type=style&index=0&id=09927ae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09927ae0",
  null
  
)

export default component.exports